// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2LAgb","title":"ClientInsurance_title__2lniX","itemText":"ClientInsurance_itemText__3FAVc"};